/* eslint-disable import/no-webpack-loader-syntax */
import Colors from '!!sass-variables-loader!colors.scss';

export default Colors;
